import fieldsArrSheet from 'fields/FieldsArrSheet';

export default {
  TextArray: {
    position: 'relative',
    width: '100%',
  },
  ...fieldsArrSheet,
};
